// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-card {
  background-color: transparent;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
}
.contact-card .image-container {
  border: 7px solid #E7E7E7;
  border-radius: 50%;
  margin-right: 1rem;
}
.contact-card .info-container {
  opacity: 0.9;
  flex: 1;
}
.contact-card .info-container .info-col {
  display: flex;
  flex-direction: column;
}
.contact-card .info-container .info-row {
  display: flex;
  flex-direction: row;
}
.contact-card .avatar {
  height: 82px;
  width: 82px;
}
.contact-card .name {
  color: #FFFFFF;
  font-size: 13px;
  font-weight: normal;
}
.contact-card .role {
  color: #FFFFFF;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.85px;
}
.contact-card .info, .contact-card .email {
  color: #FFFFFF;
  font-size: 13px;
  font-weight: normal;
  letter-spacing: 0.75px;
}
.contact-card .email {
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/components/about/contact-card/contact-card.component.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AACF;AACE;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;AACJ;AAEE;EACE,YAAA;EACA,OAAA;AAAJ;AAEI;EACE,aAAA;EACA,sBAAA;AAAN;AAGI;EACE,aAAA;EACA,mBAAA;AADN;AAKE;EACE,YAAA;EACA,WAAA;AAHJ;AAME;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AAJJ;AAOE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AALJ;AAQE;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AANJ;AASE;EAEE,gBAAA;AARJ","sourcesContent":[".contact-card {\n  background-color: transparent;\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  align-items: center;\n\n  .image-container {\n    border: 7px solid #E7E7E7;\n    border-radius: 50%;\n    margin-right: 1rem;\n  }\n\n  .info-container {\n    opacity: 0.9;\n    flex: 1;\n\n    .info-col {\n      display: flex;\n      flex-direction: column;\n    }\n\n    .info-row {\n      display: flex;\n      flex-direction: row;\n    }\n  }\n\n  .avatar {\n    height: 82px;\n    width: 82px;\n  }\n\n  .name {\n    color: #FFFFFF;\n    font-size: 13px;\n    font-weight: normal;\n  }\n\n  .role {\n    color: #FFFFFF;\n    font-size: 13px;\n    font-weight: bold;\n    letter-spacing: 0.85px;\n  }\n\n  .info {\n    color: #FFFFFF;\n    font-size: 13px;\n    font-weight: normal;\n    letter-spacing: 0.75px;\n  }\n\n  .email {\n    @extend .info;\n    font-weight: 500;\n    // text-decoration: underline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
